import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';

import * as Sentry from '@sentry/vue';
import AnalyticsHelper from 'dashboard/helper/AnalyticsHelper';
import App from '../v3/App.vue';
import router, { initalizeRouter } from '../v3/views/index';
import store from '../v3/store';
import { loadAuthMessages } from '../v3/helpers/authI18n';

async function boot() {
  const locale = window.chatwootConfig?.selectedLocale || 'en';
  const messages = await loadAuthMessages(locale);
  const i18n = createI18n({
    legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
    locale,
    fallbackLocale: 'en',
    messages,
  });

  const app = createApp(App);
  app.use(i18n);
  app.use(store);
  app.use(router);

  if (window.errorLoggingConfig) {
    Sentry.init({
      app,
      dsn: window.errorLoggingConfig,
      denyUrls: [
        // Chrome extensions
        /^chrome:\/\//i,
        /chrome-extension:/i,
        /extensions\//i,

        // Locally saved copies
        /file:\/\//i,

        // Safari extensions.
        /safari-web-extension:/i,
        /safari-extension:/i,
      ],
      integrations: [Sentry.browserTracingIntegration({ router })],
      ignoreErrors: [
        'ResizeObserver loop completed with undelivered notifications',
      ],
    });
  }

  AnalyticsHelper.init();
  initalizeRouter();
  app.mount('#app');
}

boot();
